export default __webpack_public_path__ + "static/media/hema.a22bcede.jpeg";